<template>
  <!-- TODO: support nesting children (like the fields) -->
  <!--  :class="{ 'hide-not-visible': hideNotVisible }" -->
  <b-container fluid style="padding: 0">
    <b-row no-gutters style="width: 100%;">
      <b-card no-body class="col-12" border-variant="primary">
        <b-card-header class="m-2 sale-rep-nav background-color-primary" header-text-variant="white" header-tag="h2" v-if="showHeader">
          {{ treeTitle }}
          <b-button-toolbar class="float-md-right">
            <slot name="toolbar-buttons"></slot>
            <b-button-group size="sm" class="mx-1">
              <b-dropdown right split title="Reload Selected Tree" variant="light" size="sm"
                @click="refresh(true)">
                <template v-slot:button-content>
                  <b-icon icon="arrow-repeat" variant="info" aria-hidden="true"></b-icon>
                </template>

                <b-dropdown-item-button @click="refresh(false)">
                  <b-icon icon="arrow-repeat" variant="info" aria-hidden="true"></b-icon>
                  Refresh Entire Tree
                </b-dropdown-item-button>
              </b-dropdown>
            </b-button-group>
          </b-button-toolbar>
        </b-card-header>
        <b-card-body class="scrollable-tree">
          <b-row no-gutters style="width: 100%;" v-if="treeLoading">
            <loading-text v-if="treeLoading"></loading-text>
          </b-row>
          <b-row no-gutters style="width: 100%;" v-if="!treeLoading && items">
            <tree-item v-for="(item, i) in items" :key="i" :item="item" :activeId="activeId" :activeEntityObjectId="activeEntityObjectId" @itemSelected="onItemSelected" :childProperty="childPropertyNext" :childProperties="childPropertiesNext" :activeItemIds="activeItemIds" :activeItem="activeItem" :entityObject="entityObject" :searchTerm="searchTerm" :defaultActiveItem="defaultActiveItem" :defaultActiveEntityObject="defaultActiveEntityObject" :defaultActiveItemIds="defaultActiveItemIds" :defaultActiveItemId="defaultActiveItemId" />
          </b-row>
        </b-card-body>
        <b-modal v-model="selectingItem" size="md" @ok="selectItem(entityObject, pendingActiveItem)" @hide="selectingItem = false" dialog-class="float-md-center" ok-title="Yes" cancel-title="No">
          <template #modal-header>
            The current {{ entityObject.DisplayName }} has unsaved changes
          </template>
          <span class="text-info">Selecting {{ getTitleByEntityObject(entityObject, activeItem) }} will discard all of the pending changes to {{ getTitleByEntityObject(entityObject, activeItem) }}</span><br /><br />
          <span class="text-danger">Are you sure?</span>
        </b-modal>
      </b-card>
    </b-row>
  </b-container>

</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'

import LoadingText from '@/components/utility/loading-text.vue'
import TreeItem from './tree-item.vue'

import MxSite from '@/mixins/site'
import { EntityBase } from '@/store/types'
import { EntityProperty, EntityObject } from '@/store/entity/types'

@Component({
  components: {
    'loading-text': LoadingText,
    'tree-item': TreeItem,
  },
})
export default class extends Mixins(MxSite) {
  public items: any[] = []
  public activeId: any = -1
  public activeEntityObjectId: any = -1

  public activeItemIds: any[] = [] // a list of active items

  public selectingItem = false
  public pendingActiveItem: any = {}

  @Prop({ default: true })
  public showHeader!: boolean

  @Prop()
  public treeTitle!: string

  @Prop()
  public getItems!: (refresh?: boolean) => Promise<EntityBase[]>

  @Prop()
  public childProperty!: EntityProperty

  @Prop()
  public childProperties!: EntityProperty[]

  @Prop()
  public activeItem!: any

  @Prop()
  public defaultActiveItem!: any

  @Prop()
  public defaultActiveEntityObject!: any

  @Prop()
  public defaultActiveItemIds!: number[]

  @Prop()
  public defaultActiveItemId!: number

  // TODO: not used - yet?
  @Prop()
  public activeEntityObject!: EntityObject

  @Prop()
  public entityObject!: EntityObject

  @Prop()
  public searchTerm!: any

  get childPropertyNext() {
    const { childProperties, childProperty } = this
    if (childProperties && childProperties.length > 0) {
      return childProperties[0]
    } else {
      return childProperty
    }
  }

  get childPropertiesNext() {
    const { childProperties } = this
    if (childProperties && childProperties.length > 0) {
      return childProperties.slice(1)
    }
  }

  public mounted() {
    this.refresh(false)
    this.updateActiveTree()
  }

  @Watch('activeItem')
  public updateActiveTree() {
    const { getActiveTree } = this
    // TODO: traverse and find the activeItem in the tree
    // - then we can 'Open' it...
    // - is some sort of parentage mapping helpful?
    if (this.activeId > -1) { // Q: is this good?
      const activeItemIds: any[] = []

      getActiveTree(this.items, activeItemIds)
      // note: even if the above was false, we'd still want to clear the list!
      if (!_.isEqual(activeItemIds, this.activeItemIds)) {
        Vue.set(this, 'activeItemIds', activeItemIds)
      }
      // TODO: now what? How do I use this information????
    }
  }

  public getActiveTree(items: any[], list: any[], childPropertyIndex: number = 0): boolean {
    // TODO: am I actually getting then next one for this?
    // - it wouldn't be entityObject then right?
    const { activeId, getComponentIdByEntityObject, childProperties, childProperty, getActiveTree, entityObject } = this
    // is this childProperty or entityObject or what? where is it where? I am SO CONFUSED

    // TODO: yes - it's staying as ProductClasses and failing when it should move on to ManufacturingSeries
    const currentChildProperty = childProperties ? childProperties[childPropertyIndex] : childProperty

    // the currentEntityObject is the entityObject
    // unless we've gone past the first level
    // then it's the previous ones PropertyEntityObject

    // we also don't do any of this if childProperties is undefined (I added it to the child ternary)
    const currentEntityObject = childPropertyIndex === 0
      ? entityObject
      : (childProperties ? childProperties[childPropertyIndex - 1].PropertyEntityObject : entityObject) || entityObject // though this will never be?

    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      // TODO: it cannot be entityObject here - that CHANGES
      const id = getComponentIdByEntityObject(currentEntityObject, item)
      if (id === activeId) {
        list.push(id)
        return true
      } else if (currentChildProperty) { // no need to recurse if there's no children!
        // but we haven't changed what childProperty is AT ALL with each iteration!
        // TODO: I basically need the "next" methods for this!

        // TODO: entityObject is not going to the next entityObject!
        // - it's the childProperty.PropertyEntityObject
        if (getActiveTree(item[currentChildProperty.PropertyName], list, childPropertyIndex + 1)) {
          list.push(id)
          return true
        }
      }
    }
    return false // we didn't find it so nope
  }

  @Watch('reloadTree')
  public refresh(refresh: boolean) {
    this.setTreeLoading({ value: true }).then(() => {
      this.getItems(refresh).then((items) => {
        Vue.set(this, 'items', items)
        if (this.reloadTree) {
          this.setReloadTree({ value: false })
        }
        this.setTreeLoading({ value: false })
        this.updateActiveTree()
      })
    })
  }

  public onItemSelected(entityObject: EntityObject, item: EntityBase, items: EntityBase[]) {
    if (this.activeItem.Updated) {
      this.selectingItem = true
      this.pendingActiveItem = item
    } else {
      this.selectItem(entityObject, item, items)
    }
  }

  public selectItem(entityObject: EntityObject, item: EntityBase, items: EntityBase[] = []) {
    this.activeId = this.getComponentIdByEntityObject(entityObject, item)
    this.activeEntityObjectId = entityObject.EntityObjectId
    // yes, entityObject is last since item is always needed, but entityObject is not always needed
    this.$emit('itemSelected', item, entityObject)
    this.$emit('itemsSelected', items, entityObject)
    this.pendingActiveItem = {}
  }
}
</script>
<style scoped>
.hide-not-visible .not-visible {
  display: none;
}
</style>
